import userHeartIcon from '@assets/icons/user_heart_icon.svg';
import userStarIcon from '@assets/icons/user_star_icon.svg';
import userGroupIcon from '@assets/icons/user_group_icon.svg';
import planetIcon from '@assets/icons/planet_icon.svg';

import IconCard from './IconCard';
import { IconsSectionContainer, IconsRow } from './styles';
import { useTranslation } from 'react-i18next';
import { ROOT_URL, ACCOUNT_ID } from '@utils/apiHooks';
import { useState, useEffect, useMemo } from 'react';

interface Employee {
  nationality: string;
  [key: string]: any;
}

const IconsSection = () => {
  const { t } = useTranslation();
  const [employees, setEmployees] = useState<Employee[]>([]);

  useEffect(() => {
    fetch(`${ROOT_URL}/accounts/${ACCOUNT_ID}/employees`)
      .then(async response => await response.json())
      .then(response => response?.result?.data)
      .then(data => {
        setEmployees(data);
      })
      .catch(e => {
        console.error('error = ', e);
      });
  }, []);

  
  const iconData = useMemo(() => {
    // Calculate distinct nationalities count
    const distinctNationalities = employees?.length 
      ? new Set(employees.map(employee => employee.nationality)).size 
      : 0;

    return [
      {
        iconSrc: userHeartIcon,
        count: 29453,
        description: t('home-customers'),
        alt: 'user-heart-icon',
      },
      {
        iconSrc: userStarIcon,
        count: 236,
        description: t('home-events-&-webinars'),
        alt: 'user-star-icon',
      },
      {
        iconSrc: userGroupIcon,
        count: employees?.length,
        description: t('home-colleagues'),
        alt: 'user-group-icon',
      },
      {
        iconSrc: planetIcon,
        count: distinctNationalities,
        description: t('home-nationalities'),
        alt: 'planet-icon',
      },
    ];
  }, [employees, t]);

  return (
    <section>
      <IconsSectionContainer>
        <IconsRow>
          {iconData.map((item, index) => (
            <IconCard
              key={index}
              iconSrc={item.iconSrc}
              count={item.count}
              description={item.description}
              alt={item.alt}
            />
          ))}
        </IconsRow>
      </IconsSectionContainer>
    </section>
  );
};

export default IconsSection;
